module.exports = __webpack_public_path__ + "media/illustrations/assignment_templates_org-597c3260.svg";